import { decode } from "he";

/**
 * Converts an HTML string to plain text suitable for schema.org fields.
 * Strips tags, decodes HTML entities, and normalizes whitespace.
 * Not intended as an XSS sanitizer for rendered HTML output.
 */
function stripHtml(html: string | undefined | null): string {
  if (!html) {
    return "";
  }

  return decode(html.replace(/<[^>]*>/g, ""))
    .trim()
    .replace(/\s+/g, " ");
}

export { stripHtml };
